import { TeoCore } from '@/teoCore/TeoCore';
import type { User } from '@/teoCore/User';
import { useAtomValue } from '@/utils/jotai-svelte';
import { onMountWithCore, teoCoreAtom } from '@/utils/teo-context';

export const useAuthActions = () => {
  return {
    logOut: () => TeoCore.instance.user.logOut(),
    logIn: (userName: string, password: string) => TeoCore.instance.user.logIn(userName, password),
    requestPasswortReset: (userName: string) => TeoCore.instance.api.requestPasswordReset(userName),
  };
};

export const UserAtom$ = teoCoreAtom((core) => getAuthState(core.user));
UserAtom$.onMount = onMountWithCore(({ setSelf, refresh }, core) => {
  return core.user.events.addEventListeners({
    userDataChanged: refresh,
    logInFailed: (error) => setSelf((c) => ({ ...c, error })),
    logOutFailed: (error) => setSelf((c) => ({ ...c, error })),
  });
});

export const useAuthState = () => useAtomValue(UserAtom$);

export function useAuth() {
  return [useAuthState(), useAuthActions()] as const;
}

// --- helpers ---
function getAuthState(user: User, error?: Maybe<string>) {
  if (!user) {
    return {
      user: {
        firstName: '-',
        lastName: '-',
        email: '',
        loggedIn: false,
      },
      loggedIn: false,
      error: error ?? null,
    };
  }
  return {
    user: {
      firstName: user.name?.split(' ', 1)[0] ?? '-',
      lastName: user.name?.split(' ', 2)[1] ?? '-',
      email: user.email ?? '',
      loggedIn: user.isLoggedIn,
    },
    loggedIn: user.isLoggedIn,
    error: error ?? null,
  };
}
